
import { Component, Vue } from 'vue-property-decorator';
import TacticsList from './_BackupTacticsList.vue';
import TacticsTable from './_BackupTacticsTable.vue';

@Component({
  components: {
    TacticsList,
    TacticsTable,
  },
})
export default class TerminalImport extends Vue {
  private dynamComp = 'TacticsTable';

  handleBack() {
    this.dynamComp = 'TacticsTable';
  }

  goInfo() {
    this.dynamComp = 'TacticsList';
    // this.rowDetail = obj;
  }
  mounted() {
    // if (this.$route.params.row !== undefined) {
    //   this.dynamComp = 'DeviceDetail'; // area_id
    //   this.rowDetail = JSON.parse(decodeURIComponent(this.$route.params.row));
    //   this.rowDetail.id = Number(this.rowDetail.area_id);
    //   this.rowDetail.name = String(this.rowDetail.area_name);
    // }
  }
}
